import { render } from "./TopMenu.vue?vue&type=template&id=784905cf&scoped=true"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"

import "./TopMenu.vue?vue&type=style&index=0&id=784905cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784905cf"]])

export default __exports__